import { Link as MuiLink } from '@mui/material';
import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../../routes/routes.js';
import type { MissionLockedReason } from '../../store/queries/fragments/mission/missionSubFragments.js';
import { ISODateToDate, usDateFormatter } from '../../utils/formatters.js';
import { MISSION_ID_PARAM } from '../../utils/routingHelpers.js';

type ComponentType =
  | keyof JSX.IntrinsicElements
  | ((props: { children: ReactNode }) => JSX.Element);

/** Recursive component to render tree of reasons **/
function InternalLockedStatus({
  Component,
  reason,
}: {
  Component: ComponentType;
  reason: MissionLockedReason | { __typename: 'MultipleReasons' };
}): JSX.Element {
  if (reason.__typename === 'MultipleReasons') {
    if (!('reasons' in reason)) {
      return <></>;
    }
    const reasonList = reason.reasons.map((node, i) => (
      <Fragment key={i}>
        <InternalLockedStatus Component={Component} reason={node} />
        {/*{i !== reasons.reasons.length - 1 && (*/}
        {/*  <span className="operator">{reasons.operator}</span>*/}
        {/*)}*/}
      </Fragment>
    ));

    return <div className="locked-status-container">{reasonList}</div>;
  } else {
    let action: ReactNode = reason.label;
    let display: ReactNode;

    //we're in a leaf state map the data
    switch (reason.__typename) {
      case 'PrerequisiteLevelReason':
        display = reason.name;
        break;
      case 'PrerequisiteMissionReason':
        action = '';
        display = (
          <MuiLink
            component={Link}
            color="var(--color-purple)"
            // style={{ textDecoration: 'none' }}
            underline="hover"
            to={`${ROUTES.HOME}?${new URLSearchParams({
              [MISSION_ID_PARAM]: reason.id,
            })}`}
          >
            Complete Mission: {reason.name}
          </MuiLink>
        );
        break;
      case 'StartTimeReason':
        {
          const date = ISODateToDate(reason.startTime);
          if (date) {
            action = '';
            display = `Wait until ${usDateFormatter.format(date)}`;
          }
        }
        break;
      case 'UnknownReason':
        // console.error(reason.reasonDetails);
        break;
    }

    return (
      <Component>
        <span>
          {action} {display}
        </span>
      </Component>
    );
  }
}

export function LockedStatus({
  as = 'div',
  reasons,
}: {
  as?: ComponentType;
  reasons: MissionLockedReason;
}): JSX.Element {
  return (
    <div>
      <InternalLockedStatus Component={as} reason={reasons} />
    </div>
  );
}
